import styled from 'styled-components';
import Particles from "@tsparticles/react";

export const mainContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    margin: 0;
    padding: 0;
    position: relative;
    overflow: hidden;
    color: var(--palette-one-white);
    z-index: 1;
`;
export const loginHeader = styled.div`
    width: calc(100% - 20px);
    height: 60px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;
export const headerButtonsWrapper = styled.div`
    display: flex;
    gap: 20px;
`;
export const headerButton = styled.h2`
    cursor: pointer;
    font-size: 1.15rem;
    font-weight: 500;
    transition: 0.3s;
    text-transform: uppercase;
    background-color: #1c1c1b;
    border-radius: 5px;
    &:hover {
        text-decoration: underline;
        transform: scale(1.1);
    }

    @media (max-width: 500px) {
        font-size: 1rem;
    }
`;
export const mainInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: space-between;
    overflow-y: auto;
    position: relative;
`;
export const ctaArea = styled.div`
    display: flex;
    flex-direction: column;
    z-index: 1;
    position: relative;
    gap: 40px;
    align-self: center;
    width: calc(100% - 40px);
    height: max-content;
    margin: 100px 20px 75px 20px;
`;
export const mainTitle = styled.h1`
    font-size: 3.2rem;
    font-weight: 700;
    text-align: center;
    text-shadow:
    -2px -2px 0 black,
     2px -2px 0 black,
    -2px  2px 0 black,
     2px  2px 0 black;
    border-radius: 5px;

    @media (max-width: 1200px) {
        font-size: 2.75rem;
    }
    @media (max-width: 800px) {
        font-size: 2rem;
    }
    @media (max-width: 500px) {
        font-size: 1.5rem;
    }
`;
export const subTitle = styled.h2`
    font-size: 1.3rem;
    width: 60%;
    align-self: center;
    text-align: center;
    text-shadow:
    -2px -2px 0 black,
     2px -2px 0 black,
    -2px  2px 0 black,
     2px  2px 0 black;

    @media (max-width: 1000px) {
        width: 80%;
    }
    @media (max-width: 800px) {
        width: 90%;
        font-size: 1.1rem;
    }
    @media (max-width: 500px) {
        width: 96%;
        font-size: 1rem;
    }
`;
export const startCta = styled.h3`
    font-size: 1.5rem;
    text-transform: uppercase;
    font-weight: 500;
    cursor: pointer;
    padding: 10px 100px;
    transition: color 0.3s ease;
    background-color: #0f1d8c;
    border-radius: 5px;
    transition: 0.3s;
    text-align: center;
    align-self: center;

    &:hover {
        color: #FFFCFF;
        background-color: #122fb3;
        box-shadow: 0px 0px 10px 0px rgba(255, 255, 255, 0.60);
    }

    @media (max-width: 800px) {
        padding: 10px 100px;
        font-size: 1.2rem;
    }

    @media (max-width: 500px) {
        padding: 10px 75px;
        font-size: 1rem;
    }
`;
export const advantagesArea = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: calc(100% - 40px);
    margin: 0 20px 50px 20px;
    justify-content: center;
    text-align: center;
    z-index: 1;
    gap: 20px;
`;
export const advantage = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex: 1 1 350px;
    align-self: stretch;
    padding: 20px;
    gap: 10px;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 10px;
    box-shadow: 0px 0px 10px 0px rgba(255, 255, 255, 0.60);

    @media (max-width: 850px) {
        flex: 1 1 200px;
    }
`;
export const advantageTitle = styled.h2`
    font-size: 1.25rem;
    font-weight: 600;
    width: 100%;
    text-align: start;
    border-bottom: 2px solid #FFFCFF;
`;
export const advantageSubtitle = styled.h3`
    font-size: 1rem;
    font-weight: 400;
    color: #FFFCFF;
    text-align: start;
`;
export const particles = styled(Particles)`
    z-index: 0;
    position: absolute;
`;